module.exports = __webpack_public_path__ + "img/document.9ef9408f.svg";